import { createTheme } from "@mui/material/styles";
import { useEffect, useState } from "react";
import GoogleAdsLoginLayout from "../layout/GoogleAdsLoginLayout";
import GoogleLogo from "../images/googleLogo.jpg";
import { useNavigate } from "react-router-dom";

const theme = createTheme({
  palette: {
    primary: {
      main: "#f5f6fa",
    },
    secondary: {
      main: "#3c8dbc",
    },
  },
});

const GoogleAdsController = () => {
  const navigate = useNavigate();

  const [showDataTable, setShowDataTable] = useState(false);
  const [Response, setResponse] = useState([]);
  const [access, setAccess] = useState("");
  const [customerId, setCustomerId] = useState("");
  const [showSkeleton, setShowSkeleton] = useState(false);
  const [showNoData, setShowNoData] = useState(false);
  const [showLayout, setShowLayout] = useState(false);
  const [showSnackBar, setShowSnackBar] = useState(false);

  let url = window.location.href;

  useEffect(() => {
    var urlData = new URL(url);
    var clientcustomerid = urlData.searchParams.get("clientcustomerid");
    var redirect_url = urlData.searchParams.get("redirect_uri");
    const params = new Proxy(new URLSearchParams(window.location.search), {
      get: (searchParams, prop) => searchParams.get(prop),
    });
    const Auth = params.authorization;
    const authenticated = localStorage.getItem("authenticated");
    if (Auth) {
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Basic ${Auth}`);
      myHeaders.append("Access-Control-Allow-Origin", "*");
      var requestOptions = {
        method: "GET",
        headers: myHeaders,
        redirect: "follow",
      };
      fetch("https://connectors.tercept.com/api/v2.3.1/checkauth", requestOptions)
        .then((response) => response.text())
        .then((result) => {
          if (result) {
            if (Auth !== null) {
              localStorage.setItem("auth", Auth);
            }
            if (redirect_url !== null) {
              localStorage.setItem("redirect_url", redirect_url);
            }
            if (clientcustomerid !== null) {
              localStorage.setItem("clientID", clientcustomerid);
              localStorage.setItem("authenticated", true);
            }
            setShowLayout(true);
          }
          if (result === "") {
            navigate("/error");
          }
          console.log(result);
        })
        .catch((error) => {
          navigate("/error");
          console.log("error", error);
        });
    } else{
      navigate("/unauthorized");
    }
  }, []);

  useEffect(() => {
    const auth = localStorage.getItem("auth");
    const clientCustomerId = localStorage.getItem("clientID");
    const redirect_url = localStorage.getItem("redirect_url");

    var urlData = new URL(url);
    var code = urlData.searchParams.get("code");
    console.log(code);

    if (code) {
      setShowSkeleton(true);
      var requestOptions = {
        method: "POST",
      };
      fetch(
        `https://oauth2.googleapis.com/token?client_id=${process.env.REACT_APP_GOOGLE_ADS_CLIENT_ID_TERCEPT}&client_secret=${process.env.REACT_APP_GOOGLE_ADS_CLIENT_SECRET_TERCEPT}&code=${code}&grant_type=authorization_code&redirect_uri=https://connectors.tercept.com/oauthcallback`,
        requestOptions
      )
        .then((response) => response.json())
        .then((result) => {
          console.log(result);
          if (result.error === "invalid_grant") {
            setShowSkeleton(false);
            navigate(
              `/googleads?authorization=${auth}&clientcustomerid=${clientCustomerId}&redirect_uri=${redirect_url}`
            );
            return;
          }

          setAccess(result.refresh_token);

          var CustomerListHeaders = new Headers();
          CustomerListHeaders.append("Access-Control-Allow-Origin", "*");
          CustomerListHeaders.append("Authorization", `Basic ${auth}`);
          var requestAccessOptions = {
            method: "GET",
            headers: CustomerListHeaders,
            redirect: "follow",
          };
          fetch(
            `https://connectors.tercept.com/api/v2.3.1/googleads/getcustomerlist?refreshToken=${result.refresh_token}`,
            requestAccessOptions
          )
            .then((response) => response.text())
            .then((res) => {
              if (JSON.parse(res).status === 500) {
                setShowNoData(true);
              }

              let result = res
                .substring(1)
                .substring(0, res.length - 2)
                .split(",");
              result.forEach((item, id) => {
                result[id] = {
                  name: item.slice(11).slice(0, -1),
                  checked: false,
                };
              });
              setResponse(result);
              setShowSkeleton(false);
              setShowDataTable(true);
            })
            .catch((err) => {
              console.log(err);
            });
        })
        .catch((error) => console.log("error", error));
    }
  }, [url]);

  const handleGoogleSignIn = async () => {
    window.location.assign(
      `https://accounts.google.com/o/oauth2/v2/auth/oauthchooseaccount?access_type=offline&client_id=${process.env.REACT_APP_GOOGLE_ADS_CLIENT_ID_TERCEPT}&redirect_uri=https://connectors.tercept.com/oauthcallback&response_type=code&scope=https://www.googleapis.com/auth/adwords&state=callback&prompt=consent`
    );
  };

  const handleSubmit = async () => {
    const redirect_url = localStorage.getItem("redirect_url");
    const clientCustomerId = localStorage.getItem("clientID");
    const auth = localStorage.getItem("auth");

    let IdList = [];
    let res = Response;
    res = res.filter((val) => val.checked === true);
    res.forEach((ids, index) => {
      return (IdList[index] = Number(ids.name));
    });

    var scheduleHeaders = new Headers();
    scheduleHeaders.append("Access-Control-Allow-Origin", "*");
    scheduleHeaders.append("Authorization", `Basic ${auth}`);
    var scheduleRequestOptions = {
      method: "GET",
      headers: scheduleHeaders,
      redirect: "follow",
    };
    fetch(
      `https://connectors.tercept.com/api/v2.3.1/googleads/schedule?customerLoginIdList=${IdList.map(
        (val) => val
      )}&clientCustomerId=${clientCustomerId}&refreshToken=${access}`,
      scheduleRequestOptions
    )
      .then((response) => response.text())
      .then((result) => {
        setShowSnackBar(true);
        setTimeout(() => {
          window.location.assign(redirect_url);
          return;
        }, 5000);
        console.log(result);
      })
      .catch((error) => console.log("error", error));
  };

  return (
    <>
      {true ? (
        <GoogleAdsLoginLayout
          handleGoogleSignIn={handleGoogleSignIn}
          theme={theme}
          GoogleLogo={GoogleLogo}
          handleSubmit={handleSubmit}
          setResponse={setResponse}
          showDataTable={showDataTable}
          access={access}
          Response={Response}
          setCustomerId={setCustomerId}
          customerId={customerId}
          showSkeleton={showSkeleton}
          showNoData={showNoData}
          setShowNoData={setShowNoData}
          setShowDataTable={setShowDataTable}
          showSnackBar={showSnackBar}
          setShowSnackBar={setShowSnackBar}
          setShowSkeleton={setShowSkeleton}
        />
      ) : (
        <div></div>
      )}
    </>
  );
};

export default GoogleAdsController;
